import React, { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Routes, Route } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import Body from './components/Body';
import BlogsPage from './pages/BlogsPage';
import { Link } from "react-router-dom";
import './App.css';
import ContactUs from './pages/ContactUsPage';
import Logo from './pngs/hd-logo.png';
import Loader from './components/loader';
import PortfolioPage from './pages/PortfolioPage';
import { useLocation } from 'react-router-dom';
import SingleBlogPage from './pages/SingleBlogPage';
import CaseStudyPage from './pages/CaseStudyPage';
import OurTeam from './pages/OurTeam';
import OurClients from './pages/OurClientsPage';
import OurTestimonialPage from './pages/OurTestimonialPage';
import AboutOmkatech from './pages/AboutOmkatech';
import CarrerPage from './pages/CarrerPage';
import SinglePortfolioPage from './pages/SinglePortfolioPage';
import HireResource from './pages/HireResource';
import SingleCasestudyPage from './pages/SingleCasestudyPage';
import ServicePage from './pages/ServicePage';
import CertificatePage from './pages/CertificatePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AntiSpamPolicy from './pages/AntiSpamPolicy';

import { Helmet } from 'react-helmet-async';
import Sitemap from './pages/Sitemap';
import ScrollToTop from './components/ScrollToTop';
import Sop from './pages/Sop'
import TemplatePage from './pages/TemplatePage'
import ProtectedRoute from './ProtectedRoute';
import CaseStudyListing from './pages/CaseStudyListing'
import CaseStudyDetail from './pages/CaseStudyDetail'  // ← NEW
import TermsConditions from './pages/Terms&Conditions'

const App = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const textControls = useAnimation();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      setIsHeaderVisible(true);
      const timeout = setTimeout(() => {
        setIsHeaderVisible(false);
        animateText();
      }, 2500);
      return () => clearTimeout(timeout);
    } else {
      setIsHeaderVisible(false);
    }
  }, [location.pathname]);

  const animateText = async () => {
    await textControls.start({
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: 'easeOut' },
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const shouldHideFooter = ['/sales-sop', '/sales-sop/', '/sales-sop/templates', '/sales-sop/templates/'].includes(location.pathname);
  const shouldShowSopHeader = ['/sales-sop', '/sales-sop/', '/sales-sop/templates', '/sales-sop/templates/'].includes(location.pathname);

  // Hide header & footer on seo-case-study detail pages too
  // const isSeoDetailPage = location.pathname.startsWith('/seo-case-study/');

  const shouldShowFooter = !shouldHideFooter && !(location.pathname === '/' && isHeaderVisible);
  const shouldShowHeader = !shouldShowSopHeader && location.pathname !== '/';

  return (
    <div className="main-container">
      <Helmet>
        <title>Omka Tech - Web & App Development Company in the USA</title>
        <meta
          name="description"
          content="Omka Tech is a global IT agency offering web development, mobile app solutions, and digital marketing services in the USA, Canada, and India."
        />
        <link rel="canonical" href="https://omkatech.com/" />
      </Helmet>

      <div>
        {/* Show custom header for SOP routes */}
        {shouldShowSopHeader && (
          <div className="sop-main-header" style={{
            backgroundColor: '#000',
            padding: '20px 20px 20px 60px',
            position: 'sticky',
            top: 0,
            zIndex: 1000
          }}>
            <Link to="/"><img src={Logo} alt="OmkaTech" style={{ height: '40px' }} /></Link>
          </div>
        )}

        {/* Show regular header for other routes (except home & seo detail) */}
        {shouldShowHeader && <Header />}

        {/* Add spacer only when regular header is shown */}
        {shouldShowHeader && <div className="header-spacer"></div>}

        <Routes>
          <Route path="/" element={<Body />} />
          <Route path="blogs" element={<BlogsPage />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="/portfolio/:id" element={<SinglePortfolioPage />} />
          <Route path="case-study" element={<CaseStudyPage />} />
          <Route path="our-team" element={<OurTeam />} />
          <Route path="/blog/:id" element={<SingleBlogPage />} />
          <Route path="/our-clients" element={<OurClients />} />
          <Route path="/our-testimonials" element={<OurTestimonialPage />} />
          <Route path="/about-us" element={<AboutOmkatech />} />
          <Route path="/career" element={<CarrerPage />} />
          <Route path="/hire-resources" element={<HireResource />} />
          <Route path="/case-study/:id" element={<SingleCasestudyPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/certifications" element={<CertificatePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/anti-spam-policy" element={<AntiSpamPolicy />} />
          <Route path="/terms-&-conditions" element={<TermsConditions />} />
          <Route path="/seo-case-study" element={<CaseStudyListing />} />
          <Route path="/seo-case-study/:id" element={<CaseStudyDetail />} />  {/* ← NEW */}
          <Route
            path="/sales-sop"
            element={
              // <ProtectedRoute>
              <Sop />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/sales-sop/templates"
            element={
              <ProtectedRoute>
                <TemplatePage />
              </ProtectedRoute>
            }
          />
          <Route path="/sitemap" element={<Sitemap />} />
        </Routes>

        {shouldShowFooter && <Footer />}

        {/* WhatsApp and Contact Us buttons */}
        {!shouldHideFooter && (
          <div className="contact-buttons">
            <a
              href="https://wa.me/17866482910?text=Hello%20Team%20Omka%20Tech"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="whatsapp-button">WHATSAPP</button>
            </a>
            <Link className='contact-us' to="contact-us">
              <button className="contact-us-button">CONTACT US</button>
            </Link>
          </div>
        )}

        <ScrollToTop />
      </div>
    </div>
  );
};

export default App;